import { Injectable, NgZone } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../_services/user.service';

@Injectable()
export class UsernameGuard implements CanActivate {
  constructor(private userService: UserService,
    private zone: NgZone,
    private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.userService.getUser().map(user => {
      if (user && user.isNewRegistered) {
        this.zone.run(() => {
          this.router.navigateByUrl("/auth/saveUsername");
        });
        return false;
      }
      return true;
    })
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_guards/username.guard.ts